import { UserDomainEnum } from './user-domain-enum'

export interface OperatorInterface {
  rid: number
  /**
   * 用户所属领域
   */
  domain: UserDomainEnum
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 用户所属学校 id
   */
  schoolId?: number | null
  /**
   * 手机号
   */
  phone?: string | null
  /**
   * 头像
   */
  avator?: string | null
  /**
   * 用户身份【目前仅前台用户使用】
   */
  role?: string | null
  /**
   * 用户状态【目前仅前台用户使用】
   */
  status?: string | null
  /**
   * 用户学工号【目前仅前台用户使用】
   */
  usin?: string | null
  /**
   * 用户归档时【目前仅前台用户使用】
   */
  archivedAt?: string | null
}

export class Operator implements OperatorInterface {
  rid: number
  /**
   * 用户所属领域
   */
  domain: UserDomainEnum
  /**
   * 用户名
   */
  name: string
  /**
   * 账户
   */
  account: string
  /**
   * 用户所属学校 id
   */
  schoolId?: number | null
  /**
   * 手机号
   */
  phone?: string | null
  /**
   * 头像
   */
  avator?: string | null
  /**
   * 用户身份【目前仅前台用户使用】
   */
  role?: string | null
  /**
   * 用户状态【目前仅前台用户使用】
   */
  status?: string | null
  /**
   * 用户学工号【目前仅前台用户使用】
   */
  usin?: string | null
  /**
   * 用户归档时【目前仅前台用户使用】
   */
  archivedAt?: string | null

  constructor(props: OperatorInterface) {
    const {
      // 重命名变量以规避与 JS 保留词的冲突, 比如 default, with
      rid: _rid,
      domain: _domain,
      name: _name,
      account: _account,
      schoolId: _schoolId,
      phone: _phone,
      avator: _avator,
      role: _role,
      status: _status,
      usin: _usin,
      archivedAt: _archivedAt,
      // 可能会有额外字段比如自定义字段不在类型定义中
      ...rest
    } = props

    Object.assign(this, rest)

    this.rid = _rid
    this.domain = _domain
    this.name = _name
    this.account = _account
    this.schoolId = _schoolId
    this.phone = _phone
    this.avator = _avator
    this.role = _role
    this.status = _status
    this.usin = _usin
    this.archivedAt = _archivedAt
  }
}
